import {Request} from '@group-devs/yfp7-global-modules'
import {useEffect} from 'react'
import {Footer} from '@group-devs/yfp7-global-modules/components/Block'
import Head from 'next/head'
import ReactGA from 'react-ga';

const request = new Request(process.env.apiDomain)

function Lcw(props) {
    const site = props.global.site
    const {data: hub} = request.website.swrSite(site.accountId, "HUB")
    const {data: nav} = request.website.swrNavigation(hub ? hub.url : hub)
    const {data: tracker} = request.insights.swrTracking(site.id)

    useEffect(()=>{
        if (tracker)
        {
            if (tracker.ga_id)
            {
                ReactGA.initialize(tracker.ga_id);
                ReactGA.pageview(window.location.pathname + window.location.search);
            }
            if (tracker.matomo_id && tracker.matomoServer)
            {
                var _paq = window._paq = window._paq || [];
                _paq.push(['trackPageView']);
                _paq.push(['enableLinkTracking']);
                (function() {
                    var u= (tracker.matomoServer.includes("http") ? "" : "//") + tracker.matomoServer.replace(/\/$/, "");
                    _paq.push(['setTrackerUrl', u+'/matomo.php']);
                    _paq.push(['setSiteId', tracker.matomo_id]);
                    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                    g.type='text/javascript'; g.async=true; g.src=u+'/matomo.js'; s.parentNode.insertBefore(g,s);
                })();
            }
        }
    }, [tracker])
    
    return (
        <>
            <Head>
                <meta property="og:url" content={props.ogurl}/>
                <meta property="og:site_name" content={props.ogsiteName}/>
                <meta property="og:title" content={props.ogsiteName}/>
                <meta property="og:description" content={props.ogsiteDesc}/>
                <meta property="og:image" content={props.ogImg}/>
                <link rel="shortcut icon" type="image/x-icon" href={props.ogIcon}/>
                <title>{props.ogsiteName}</title>
            </Head>
            {props.children}
            { nav ? <Footer host={props.global.host} site={site} navigation={nav.footer_navigation} /> : null }
            <style jsx global>{`
                @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
                @import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap');
				@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');
                body {
                    font-family: "Open Sans", sans-serif;
                }

                @media (min-width: 1200px) { ... }

                @media (min-width: 992px) and (max-width: 1199.98px) { ... }

                @media (min-width: 768px) and (max-width: 991.98px) { ... }

                @media (min-width: 576px) and (max-width: 767.98px) { ... }

                @media (max-width: 575.98px) { ... }

                .footer__copyright{
                    background-color: #2a2829!important;
                }
            `}</style>
        </>
    )
}

export default Lcw
